/**
 * This code transformed directly via Babel and inlined into index.html
 * Don't try to import it.
 */
(function checkBrowser() {
  const BAD_BROWSER_URL = 'https://mail.ru/badbrowser';
  const userAgent = (navigator && navigator.userAgent || '').toLowerCase();
  const BROWSERS = [
    {
      id: 'ie',
      minVersion: 10,
      versionRegexp: /(?:msie |trident.+?; rv:)(\d+)/,
    }, {
      id: 'opera',
      minVersion: 15,
      versionRegexp: /(?:^opera.+?version|opr)\/(\d+)/,
    }, {
      id: 'firefox',
      minVersion: 29,
      versionRegexp: /(?:firefox|fxios)\/(\d+)/,
    }, {
      id: 'safari',
      minVersion: 8,
      versionRegexp: /version\/(\d+).+?safari/,
    },
    // TODO: test old android devices
  ];
  /**
   * Returns browser version
   *
   * @param  {RegExp} regExp
   * @returns {Number|Boolean}
   */
  function getBrowserVersion(regExp) {
    const match = userAgent.match(regExp);
    return Boolean(match) && parseInt(match[1]);
  }
  /**
   * Checks one by one all known browsers
   *
   * @returns {Boolean}
   */
  function checkBrowserSupport() {
    for (let i = 0; i < BROWSERS.length; i++) {
      const browser = BROWSERS[i];
      const version = getBrowserVersion(browser.versionRegexp);
      if (version && version < browser.minVersion) {
        return false;
      }
    }
    return true;
  }
  /**
   * Display unsupported browser alert
   */
  function showUnsupportedAlert() {
    // ga('send', 'event', 'Errors', 'Unsupported Browser Detected');

    if (window.top && window.top.location.href){
      window.top.location.href = BAD_BROWSER_URL;
    }else{
      location.href = BAD_BROWSER_URL;
    }
  }
  const isBrowserSupported = checkBrowserSupport();
  if (!isBrowserSupported) {
    showUnsupportedAlert();
  }
}());



// WEBPACK FOOTER //
// ./src/utils/checkBrowser.js